module.exports = __webpack_public_path__ + "img/13.1aa4cc08.svg";